import countries from '../variables/countries.json';

export const getReferralCountry = (referral, commissionId = referral?.commissionId) => {
  // Multi-territory agents use the selected commission, not their home territory.
  const commission = referral?.webstarDetails?.find(item => item?._id === commissionId);
  const countryCode = commission?.country || referral?.territory;
  // Portal routing uses alpha2 codes; agent territories may use alpha3 (ABW -> AW).
  return countries.find(
    country => country.alpha2 === countryCode || country.alpha3 === countryCode,
  )?.alpha2;
};
